export default __webpack_public_path__ + "static/media/circlePurple.19eafb9f.svg";